import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon } from "semantic-ui-react";

import { useCan } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { CreateApiKeyModal, LocationIdsModal } from "modules/AccessKeysDashboard/components";
import "modules/AccessKeysDashboard/components/AccessKeysDashboardToolbar/AccessKeysDashboardToolbar.scss";

const PUBLIC_API_LINK = "https://public-api.claireit.com/#introduction";

export const AccessKeysDashboardToolbar = () => {
  const { t } = useTranslation();

  const [showLocationIdsModal, setShowLocationIdsModal] = useState(false);
  const [showCreateApiKeyModal, setShowCreateApiKeyModal] = useState(false);
  const canCreateApiKey = useCan(ACL_ACTIVITIES.Create, ACL_RESOURCES.PublicAPI);

  const handleOpenApiDocs = () => window.open(PUBLIC_API_LINK, "_blank");

  return (
    <div className="AccessKeysDashboardToolbar">
      <Button basic icon className="add-btn" disabled={!canCreateApiKey} onClick={() => setShowCreateApiKeyModal(true)}>
        <Icon className="plus" />
      </Button>

      <div className="create-api-key-container">
        <Button icon labelPosition="left" fluid className="action-button-container" onClick={() => setShowLocationIdsModal(true)}>
          <div className="create-api-key-icon-text-container">
            <Icon className="question create-api-key-icon" />
            <div className="create-api-key-text-container-no-border">
              <span className="create-api-key-text-no-border">{t("v8_location_ids", "Location ID's")}</span>
            </div>
          </div>
        </Button>
      </div>

      <div className="create-api-key-container">
        <Button icon labelPosition="left" fluid className="action-button-container" onClick={handleOpenApiDocs}>
          <div className="create-api-key-icon-text-container">
            <Icon className="book create-api-key-icon" />
            <div className="create-api-key-text-container-no-border">
              <span className="create-api-key-text-no-border">{t("v8_api_docs", "API Docs")}</span>
            </div>
          </div>
        </Button>
      </div>

      <LocationIdsModal onClose={() => setShowLocationIdsModal(false)} open={showLocationIdsModal} />
      <CreateApiKeyModal isOpen={showCreateApiKeyModal} onClose={() => setShowCreateApiKeyModal(false)} />
    </div>
  );
};
